import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, FormikHelpers, FormikValues } from 'formik';
import { LoadingButton } from '@mui/lab';
import Style from '../../utils/styles/Style';
import PAGE_ROUTES, { API_ROUTES } from '../../utils/constant';
import { toast } from 'react-toastify';
import axios from 'axios';

function ForgetPassword() {
  const [isLoading, setIsLoading] = React.useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
  });

  interface FormValues {
    email: string;
  }

  const navigate = useNavigate();

  return (
    <Box>
      <Container
        component="main"
        sx={Style.LoginForm?.SubContainer}
        maxWidth="xs"
      >
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            onSubmit={async (
              values: FormikValues,
              { resetForm }: FormikHelpers<FormValues>
            ) => {
              // Handle form submission
              setIsLoading(true);

              try {
                const resData = {
                  email: values.email,
                };
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}${API_ROUTES.forgetPassword}`,
                  resData
                );

                navigate(PAGE_ROUTES.LOGIN);
                toast.success(
                  'Success! Check your email for the password reset link. Follow the instructions to regain access and get back to gaming!',
                  {
                    position: 'bottom-right',
                  }
                );
                setIsLoading(false);
              } catch (error: any) {
                setIsLoading(false);
                console.error('Error in Loging', error.response.data.message);
                toast.error(error.response.data.message, {
                  position: 'bottom-right',
                });
              }
            }}
          >
            {({
              errors,
              touched,
              handleSubmit,
              handleBlur,
              handleChange,
              isSubmitting,
            }) => (
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  onChange={handleChange}
                  autoComplete="email"
                  error={touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                />

                <LoadingButton
                  loading={isLoading}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, textTransform: 'none' }}
                >
                  Send Email
                </LoadingButton>
              </Box>
            )}
          </Formik>
        </Box>
      </Container>
    </Box>
  );
}

export default ForgetPassword;
